// Single source of truth for the backend (Render) proxy URL.
//
// If the Render service URL ever changes, update it HERE ONLY — every page
// imports API_BASE from this file. Optionally set REACT_APP_API_URL at build
// time to override it without editing code.
export const API_BASE =
  process.env.REACT_APP_API_URL || 'https://brick-audit.onrender.com';

// Shared key sent on every backend request so the proxy can reject traffic
// that isn't coming from this app. NOTE: because this is a public web app,
// this value ships in the built bundle — it stops random/automated abuse of
// the open backend URL, not a determined attacker who reads the code. The
// matching value goes in the Render env var APP_SHARED_SECRET; the server
// only enforces the check when that env var is set (safe rollout + kill
// switch). To rotate: change it here AND in Render, then rebuild + redeploy.
export const APP_KEY = 'ba_live_7f3c9a21e6b84d05af2c1e9d4b6083fa';

// Attach the key to every request aimed at our backend, without having to
// touch each fetch() call across the app. Only requests to API_BASE are
// affected (Supabase, BrickLink images, etc. are left untouched).
if (typeof window !== 'undefined' && !window.__baFetchWrapped) {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url && url.indexOf(API_BASE) === 0) {
        init = { ...(init || {}) };
        init.headers = { ...(init.headers || {}), 'x-ba-key': APP_KEY };
      }
    } catch (e) { /* fall through to a normal fetch */ }
    return nativeFetch(input, init);
  };
  window.__baFetchWrapped = true;
}
